import { ObservableArray, View } from "binder"
import { column, PopupColumnsEditorViewModel } from "./popupColumnsEditor-viewModel"

export class PopupColumnsEditorView extends View<PopupColumnsEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-EF1EA587-829D-4A99-882B-09C948A00173"
    }
    loadHtml(): string {
        let element = require('./popupColumnsEditor.html').default;
        let style = require('./popupColumnsEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set columns(v: ObservableArray<column>) { this._columns = v; } public get columns(): ObservableArray<column> { return this._columns;} private _columns: ObservableArray<column>;
    
    public addColumn(){
        this.dataContext.addColumn();
    }
    public confirm(){
        this.dataContext.confirm();
    }
    public back(){
        this.dataContext.back();
    }
}
